import { onErrorCaptured, ref } from "vue-demi";

import { useApi } from "./api";

/**
 * @param {String} url
 * @param {import("./fetch").UseFetchExParams} params
 * @param {import("vue-demi").Ref<any>} queryParams
 * @returns
 */
export function useWidgetApi(url, queryParams = ref(null)) {
  const q = useApi(url, { immediate: false });
  const lastUpdate = ref(new Date());

  const execute = () => {
    lastUpdate.value = new Date();
    return q.execute(null, queryParams.value);
  };

  onErrorCaptured(() => {
    q.clear();
    q.error.value = true;
  });

  execute();

  return {
    ...q,
    lastUpdate,
    refresh: execute,
    execute
  };
}
